/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_In_Reason_From_Product_PackagingInputs */

const vi_pll_in_reason_from_product_packaging = /** @type {(inputs: Pll_In_Reason_From_Product_PackagingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đóng gói từ thành phẩm`)
};

/**

* @param {Pll_In_Reason_From_Product_PackagingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_in_reason_from_product_packaging = /** @type {((inputs?: Pll_In_Reason_From_Product_PackagingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_In_Reason_From_Product_PackagingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_in_reason_from_product_packaging(inputs)
});